import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const useCurrentUserInfo = () => {
  const storedUserInfo = useSelector((state: RootState) => state.userInfo);
  return storedUserInfo;
};

export default useCurrentUserInfo;
